import { defineComponent } from 'vue';
import { faCheck, faCircleNotch, faTimes } from "@fortawesome/free-solid-svg-icons"

import { ItemTypeWrapper, Wemi, getTranslatedString } from '@skinsoft/types';
import { futureLocation } from '@skinsoft/search-data-store/src/search-result-selectors';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { ItemCard, SearchResultItemCard } from '@skinsoft/ui';


export const ContainerItemCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sSearchResultItemCard: SearchResultItemCard,
        sItemCard: ItemCard,
    },
    props: ['item', 'canDelete'],
    template: require('./container-item-card.html'),
    data() {
        return {
            futureLocation: '',
            deleting: false,
            isBeingDeletedId: '', // when item changes the component is not recreated and keep old values
                                   // sometimes the change event is triggered when the item is still the same
                                   // so we keep id of the item in isBeingDeleted state to know if we keep or not the state

            checkIcon: faCheck,
            crossIcon: faTimes,
            spinnerIcon: faCircleNotch,
        }
    },
    computed: {
        isBeingDeleted: {
            get(): boolean {
                if(this.item.item && this.isBeingDeletedId) {
                    let id = (this.item.item as any).id ? (this.item.item as any).id : (this.item.item as Wemi).item?.id

                    return this.isBeingDeletedId === id
                }

                return false
            },
            set(value: boolean) {
                if(value) {
                    let id = (this.item.item as any).id ? (this.item.item as any).id : (this.item.item as Wemi).item?.id
                    this.isBeingDeletedId = id
                } else {
                    this.isBeingDeletedId = ''
                }
            },
        },
    },
    mounted() {
        this.getFutureLocation()
    },
    methods: {
        getFutureLocation() {
            if(this.item) {
                // @ts-ignore
                const location = futureLocation(this.item.item)
                if(location) {
                    // @ts-ignore
                    this.futureLocation = getTranslatedString(location.path, this.getAppLocale())
                } else {
                    this.futureLocation = ''
                }
            }
        },

        onLongPress() {
            if(this.canDelete) {
                this.isBeingDeleted = !this.isBeingDeleted
            }
        },

        onDelete() {
            this.deleting=true
            this.$emit('delete', this.item)
        },

        onCancelDelete() {
            this.isBeingDeleted = false
        },
    },
    watch: {
        item: {
            handler() {
                if (this.item?.item) {
                    this.getFutureLocation()
                }
            },
            immediate: true,
            deep: true,
        },
    },
})
